import { ReactElement, useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Dashboard } from "../views/dashboard";
import { ROUTES, UI_AUTHENTICATED_ROUTES } from "./routes";
import { NotFound } from "../components/NotFound";
import { Header, DashboardMenuItems } from "../components/Header";
import { Transactions } from "../views/dashboard/pages/transactions";
import { Reports } from "../views/dashboard/pages/reports";
import { Sidebar } from "../components/SideBar";
/**
 * Checks if authenticated users' session is still valid, else bounce 'em out
 * by displaying a login form as a modal.
 * @param children ReactNode
 * @returns ReactNode | null
 *
 */

type MarketplaceRouteProps = { readonly children: ReactElement };

export function ProtectedRoute({ children }: MarketplaceRouteProps) {
  const [open, setOpen] = useState(false);

  const closeSidebar = () => setOpen(false);

  return (
    <>
      <Header
        isLoggedIn
        headerStyle={{
          borderBottom: "1px solid #E1E6ED",
          zIndex: "150",
          backgroundColor: "#fff",
        }}
        menuItems={<DashboardMenuItems />}
      />

      <div className="tw-relative tw-w-full tw-h-[100vh] tw-overflow-y-hidden lg:tw-w-full tw-flex tw-items-start">
        <Sidebar closeSidebar={closeSidebar} open={open} />
        <div className=" tw-w-full tw-relative tw-min-h-screen tw-h-[100vh] tw-max-h-screen tw-overflow-y-scroll tw-scrolling  tw-p-[1em] lg:tw-p-[1.5em] tw-pb-[100px]">
          {children}
        </div>
      </div>
    </>
  );
}

export function ApplicationRoutes() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "/spa/api-marketplace-admin-portlet"
    ) {
      navigate("/dashboard/reports");
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path={ROUTES.HOME}
        element={
          <>
            <h1>Hello</h1>
          </>
        }
        index
      />
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
              <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route
          path={UI_AUTHENTICATED_ROUTES.TRANSACTIONS}
          element={<Transactions />}
        />

        <Route path={UI_AUTHENTICATED_ROUTES.REPORTS} element={<Reports />} />

        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
